import { useContext, useEffect, useState } from 'react';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { AppContext } from '../../contexts/app-context';
import GlobalStyles from '../../global-styles';
import DeviceLocationCRUD from '../../screens/onboarding/crud/deviceLocation-crud';
import { ClearIcon, SearchIcon } from '../../utils/icons';
import {
  Box, FormControl, Grid, IconButton, Input, InputAdornment, InputLabel, List, ListItem,
  ListItemText, Paper
} from '../../utils/material-ui-core';

interface DeviceLocationListProps {
  showNew: boolean;
}

const DeviceLocationList = ({ showNew }: DeviceLocationListProps) => {
  const pageStyles = LocalPageStyles();
  const globalStyles = GlobalStyles();

  const { writeLog, deviceLocationGroup } = useContext(AppContext);

  const [searchText, setSearchText] = useState("");
  const [filterDeviceLocationGroup, setFilterDeviceLocationGroup] = useState<DeviceLocationGroup[]>(deviceLocationGroup);
  const [editConfirmDialogInputOpen, setEditConfirmDialogInputOpen] = useState<boolean>(false);
  const [selectedDeviceLocation, setSelectedDeviceLocation] = useState<DeviceLocation>({ name: "", deviceLocationKey: "" });

  const newDeviceLocation = () => {
    setSelectedDeviceLocation({ name: "", deviceLocationKey: "" });
    setEditConfirmDialogInputOpen(true);
  };

  const searchTextChange = (newValue: string) => {
    setSearchText(newValue);
    if (newValue === "") {
      setFilterDeviceLocationGroup(deviceLocationGroup);
      return;
    }

    const tempDeviceLocationGroup: DeviceLocationGroup[] = [];
    deviceLocationGroup.filter((group) => {
      const filterDeviceLocationGroup = group.deviceLocations.filter((deviceLocation) => deviceLocation.name.toUpperCase().indexOf(newValue.toUpperCase()) >= 0);
      if (filterDeviceLocationGroup.length > 0) {
        tempDeviceLocationGroup.push({
          groupPrefix: group.groupPrefix,
          deviceLocations: filterDeviceLocationGroup,
        });
      }
      return "";
    });

    setFilterDeviceLocationGroup(tempDeviceLocationGroup);
  };

  const openEditConfirmDialog = (deviceLocation: DeviceLocation) => {
    writeLog("Onboarding Page", "Opening device location.", deviceLocation.name, "devicelocation");
    setSelectedDeviceLocation(deviceLocation);
    setEditConfirmDialogInputOpen(true);
  };

  const saveDeviceLocation = (confirmOutput: ConfirmOutput) => {
    setEditConfirmDialogInputOpen(false);

    if (confirmOutput.status === "delete") {
      //TODO: Delete Code
    } else if (confirmOutput.status === "save") {
      //TODO: Save Code
    }
  };

  useEffect(() => {
    if (showNew) {
      newDeviceLocation();
    }
  }, [showNew]);

  return (
    <Box p={0} component="div">
      <DeviceLocationCRUD open={editConfirmDialogInputOpen} deviceLocationKey={selectedDeviceLocation.deviceLocationKey} name={selectedDeviceLocation.name} onCallback={saveDeviceLocation} />

      <Paper elevation={0} className={pageStyles.groupPrefixDataContainer}>
        <Grid container>
          <Grid item xs={12} sm={9} md={5} lg={4} xl={4}>
            <Box p={1}>
              <FormControl className={globalStyles.formControl} fullWidth={true}>
                <InputLabel></InputLabel>
                <Input
                  id="searchText"
                  value={searchText}
                  onChange={(event: any) => {
                    searchTextChange(event.target.value);
                  }}
                  onBlur={(event: any) => {
                    searchTextChange(event.target.value);
                  }}
                  fullWidth={true}
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  }
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="clear search text"
                        onClick={() => {
                          searchTextChange("");
                        }}
                      >
                        <ClearIcon fontSize="medium" />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Box>
          </Grid>
        </Grid>

        {
          <Grid container spacing={3}>
            {filterDeviceLocationGroup.map((group, groupIndex) => {
              return (
                <Grid key={groupIndex} item xs={12} sm={6} md={4} lg={3}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Box className={globalStyles.topic}>
                        {group.groupPrefix}
                        &nbsp; ({group.deviceLocations.length})
                      </Box>
                    </Grid>
                  </Grid>

                  <List>
                    {group.deviceLocations.map((deviceLocation, locationIndex) => {
                      return (
                        <ListItem key={locationIndex} button>
                          <ListItemText
                            primary={deviceLocation.name}
                            onClick={() => {
                              openEditConfirmDialog(deviceLocation);
                            }}
                          />
                        </ListItem>
                      );
                    })}
                  </List>
                </Grid>
              );
            })}
          </Grid>
        }
      </Paper>
    </Box>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    groupPrefixContainer: {
      flexGrow: 1,
      width: "100%",
      "& .MuiTab-root": {
        minWidth: "50px",
        height: "70px",
      },
      display: "none",
    },
    groupPrefixDataContainer: {
      flexGrow: 1,
      display: "flex",
      flexDirection: "column",
      height: "calc(100vh - 350px)",
      minHeight: "200px",
      width: "100%",
      overflowY: "auto",
      overflowX: "hidden",
      backgroundColor: "transparent",
    },
    tabs: {
      borderRight: `1px solid ${theme.palette.divider}`,
    },
  })
);

export default DeviceLocationList;
